const html = require('choo/html');
const { sendTextMessage } = require('../api');

module.exports = function() {
  const dialog = function(state, emit) {
    return html`
      <send-copy-dialog
        class="h-full w-full flex flex-col items-center justify-center bg-white py-8 max-w-md mx-auto dark:bg-grey-90"
      >
        <h1 id="title" class="text-3xl font-bold mb-4">
          ${state.translate('failedToSendSMS')}
        </h1>

        <p
          class="w-full text-center font-semibold text-grey-80 dark:text-grey-40 leading-normal"
        >
          ${state.translate('failedToSendTo')}
        </p>

        <p
          id="failed-numbers"
          class="w-full text-center text-grey-80 dark:text-grey-40 leading-normal mb-1"
        >
          ${makePhoneString()}
        </p>

        <p
          class="w-full text-center font-semibold text-grey-80 dark:text-grey-40 leading-normal"
        >
          ${state.translate('password') + ':'}
        </p>

        <p
          id="failed-numbers"
          class="w-full text-center text-grey-80 dark:text-grey-40 leading-normal"
        >
          ${makePasswordString()}
        </p>

        <div class="checkbox inline-block mr-3 px-1">
          <input
            id="show-password"
            type="checkbox"
            ${state.modal.showPwd ? 'checked' : ''}
            autocomplete="off"
            onchange="${toggleShowPassword}"
          />
          <label 
            for="show-password"
            class="text-sm"
          >
            ${state.translate('showPassword')}
          </label>
        </div>

        <button
          class="my-4 px-10 btn bg-red hover:bg-red-70 rounded-lg"
          onclick="${resend}"
          title="${state.translate('tryAgain')}"
        >
          ${state.translate('tryAgain')}
        </button>
        
        <button
          class="text-red hover:text-red-70"
          onclick="${cancel}"
          title="${state.translate('cancel')}""
        >
          ${state.translate('cancel')}
        </button>
      </send-copy-dialog>
    `;

    function makePhoneString() {
      let list = '';
      let indexOfLast = state.modal.phoneList.length - 1;
      for (let i = 0; i <= indexOfLast; i++) {
        if (i === indexOfLast) {
          list += state.modal.phoneList[i];
        } else {
          list += state.modal.phoneList[i] + ', ';
        }
      }
      return list;
    }

    function makePasswordString() {
      const password = state.modal.password;
      let passwordString = '';

      if (state.modal.showPwd) {
        passwordString = password;
      } else {
        for (let i = 0; i < password.length; i++) {
          passwordString += '*';
        }
      }
      return passwordString;
    }

    function toggleShowPassword(event) {
      event.stopPropagation();

      if (event.target.checked) {
        state.modal.showPwd = true;
      } else {
        state.modal.showPwd = false;
      }
      emit('render');
    }

    async function resend(event) {
      event.stopPropagation();
      event.target.disabled = true;
      const title = document.getElementById('title');
      title.textContent = state.translate('resending');

      state.modal.phoneList = await sendTextMessage(
        state.modal.phoneList,
        state.modal.password
      );

      if (state.modal.phoneList.length > 0) {
        title.textContent = state.translate('failedToSendSMS');
        document.getElementById(
          'failed-numbers'
        ).textContent = makePhoneString();
        event.target.disabled = false;
      } else {
        title.textContent = state.translate('success');
        setTimeout(cancel.bind(null, event), 1000);
      }
    }

    function cancel(event) {
      event.stopPropagation();
      state.modal = state.nextModal;
      emit('switchModal');
    }
  };
  dialog.type = 'sms';
  return dialog;
};
